import React, { useState } from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import AdminAddProduct from './AdminAddProduct';
import { List, ListItem, ListItemText, Box, Divider } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import { printOrder } from "./PrintOrder";
import QuantityCounter from "../QuantityCounter";
import DeleteIcon from "@mui/icons-material/Delete";
import { UpdateOrder, ConfirmOrderAndSendEmail, } from "../../utils/order";
import DealChip from "../DealChip";
import {
  getUnitPrice,
  calculateItemTotal,
  calculateCartTotal,
} from "../../helpers/cartPriceHelper";
import OrderPriceWithDiscount from "./OrderPriceWithDiscount";
import { calculateOrderDiscountSummary } from "../../helpers/orderDiscountHelper";
import Swal from "sweetalert2";
import AddIcon from "@mui/icons-material/Add";
import AdminAddProductToOrderDialog from "./AdminAddProductToOrderDialog";



const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function AdminEditProductDialog({ open, handleClose, order }) {



  const [localOrder, setLocalOrder] = useState(order);
  const [saving, setSaving] = useState(false);
  const [confirming, setConfirming] = useState(false);
  const [openAddProduct, setOpenAddProduct] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);

  const getOrderProductKey = (item) => {
    const itemId = Number(
      item?.id ??
      item?.Id ??
      0
    );

    // מוצר שכבר קיים במסד
    if (itemId > 0) {
      return `db-${itemId}`;
    }

    // מוצר חדש שעדיין לא נשמר
    return item?.temporaryId;
  };

  const handleOrderProductAmountChange = (
    targetItem,
    newAmount
  ) => {
    if (Number(newAmount) <= 0) {
      setProductToDelete(targetItem);
      setDeleteDialogOpen(true);
      return;
    }

    const targetKey = getOrderProductKey(targetItem);

    setLocalOrder((previousOrder) => ({
      ...previousOrder,
      ordersProducts: previousOrder.ordersProducts.map(
        (item) =>
          getOrderProductKey(item) === targetKey
            ? {
              ...item,
              amount: Number(newAmount),
            }
            : item
      ),
    }));
  };
  const buildOrderItemsForServer = () => {
    return (localOrder?.ordersProducts || []).map((item) => ({
      id: item.isNew ? 0 : Number(item.id || 0),

      orderId: Number(localOrder.id),

      productId: Number(
        item.productId ??
        item.product?.id ??
        item.product?.Id
      ),

      productOptionId:
        item.productOptionId ??
        item.productOption?.id ??
        item.productOption?.Id ??
        null,

      amount: Number(item.amount || 1),
    }));
  };
  const saveUpdatedOrder = async () => {
    const orderItemsForServer =
      buildOrderItemsForServer();

    const discountSummary =
      calculateOrderDiscountSummary(localOrder);

    const updatedOrder = {
      ...localOrder,
      totalCost: discountSummary.finalTotal,
      ordersProducts: orderItemsForServer,
    };

    const response = await UpdateOrder(
      updatedOrder.id,
      updatedOrder
    );

    setLocalOrder((previousOrder) => ({
      ...previousOrder,
      totalCost: discountSummary.finalTotal,
    }));

    return updatedOrder;
  };
  const removeActiveFocus = () => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  };

  const handleSaveOrder = async () => {
    if (saving || confirming) return;

    try {
      setSaving(true);

      const orderItemsForServer =
        buildOrderItemsForServer();

      const discountSummary =
        calculateOrderDiscountSummary(localOrder);

      const updatedOrder = {
        ...localOrder,
        totalCost: discountSummary.finalTotal,
        ordersProducts: orderItemsForServer,
      };

      console.log("הזמנה לפני שליחה:", updatedOrder);

      const response = await UpdateOrder(
        updatedOrder.id,
        updatedOrder
      );

      console.log("תשובת עדכון הזמנה:", response);

      setLocalOrder((previousOrder) => ({
        ...previousOrder,
        totalCost: discountSummary.finalTotal,
      }));

      // מסירים פוקוס וסוגרים את חלון MUI לפני פתיחת SweetAlert
      removeActiveFocus();
      handleClose();

      // נותנים ל־Dialog זמן קצר להיסגר
      await new Promise((resolve) => setTimeout(resolve, 150));

      await Swal.fire({
        icon: "success",
        title: "השינויים נשמרו בהצלחה",
        text: "ההזמנה עודכנה במסד הנתונים.",
        confirmButtonText: "אישור",
        confirmButtonColor: "#D81B60",
      });

      window.location.reload();
    } catch (err) {
      console.error("שגיאה בשמירת ההזמנה:", err);
      console.error("תגובת השרת:", err?.response?.data);

      removeActiveFocus();

      const serverMessage =
        err?.response?.data?.message ||
        (typeof err?.response?.data === "string"
          ? err.response.data
          : null) ||
        "לא הצלחנו לשמור את השינויים.";

      await Swal.fire({
        icon: "error",
        title: "שגיאה בשמירת ההזמנה",
        text: serverMessage,
        confirmButtonText: "אישור",
        confirmButtonColor: "#D81B60",
      });
    } finally {
      setSaving(false);
    }
  };
  const handleConfirmOrder = async (event) => {
    if (saving || confirming) return;

    // מסירים מיד את הפוקוס מהכפתור שנלחץ
    event?.currentTarget?.blur();

    const isConfirmed = window.confirm(
      "ההזמנה תישמר ותישלח ללקוח במייל. האם להמשיך?"
    );

    if (!isConfirmed) {
      return;
    }

    try {
      setConfirming(true);

      // שומרים את כל השינויים במסד
      const updatedOrder = await saveUpdatedOrder();

      console.log("ההזמנה המעודכנת נשמרה:", updatedOrder);

      // שולחים את ההזמנה המעודכנת ללקוח
      const emailResponse = await ConfirmOrderAndSendEmail(
        updatedOrder.id
      );
      setLocalOrder((previous) => ({
        ...previous,
        isCustomerNotified: true,
        customerNotifiedAt: new Date().toISOString(),
      }));

      console.log("תשובת שליחת המייל:", emailResponse);

      // מוודאים שאין אלמנט פעיל בתוך ה־Dialog
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }

      // סוגרים קודם את חלון ה־MUI
      handleClose();

      // מחכים שה־Dialog וה־Backdrop ייעלמו לגמרי
      await new Promise((resolve) => setTimeout(resolve, 300));

      // רק עכשיו פותחים SweetAlert
      await Swal.fire({
        icon: "success",
        title: "ההזמנה אושרה",
        text: `ההזמנה המעודכנת נשלחה למייל של ${updatedOrder.user?.email || "הלקוח"
          }.`,
        confirmButtonText: "אישור",
        confirmButtonColor: "#D81B60",
      });

      window.location.reload();
    } catch (err) {
      console.error("שגיאה באישור ושליחת ההזמנה:", err);
      console.error("תגובת השרת:", err?.response?.data);

      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }

      const serverMessage =
        err?.response?.data?.message ||
        (typeof err?.response?.data === "string"
          ? err.response.data
          : null) ||
        "לא הצלחנו לאשר ולשלוח את ההזמנה.";

      await Swal.fire({
        icon: "error",
        title: "שגיאה באישור ההזמנה",
        text: serverMessage,
        confirmButtonText: "אישור",
        confirmButtonColor: "#D81B60",
      });
    } finally {
      setConfirming(false);
    }
  };

  const handleRemoveOrderProduct = (
    targetItem
  ) => {
    const targetKey =
      getOrderProductKey(targetItem);

    setLocalOrder((previousOrder) => ({
      ...previousOrder,

      ordersProducts:
        previousOrder.ordersProducts.filter(
          (item) =>
            getOrderProductKey(item) !== targetKey
        ),
    }));
  };
  const handleConfirmDeleteProduct = () => {
    if (!productToDelete) return;

    handleRemoveOrderProduct(productToDelete);

    setDeleteDialogOpen(false);
    setProductToDelete(null);
  };

  const handleCancelDeleteProduct = () => {
    setDeleteDialogOpen(false);
    setProductToDelete(null);
  };
  const handleAddProductToOrder = (newItem) => {
    setLocalOrder((previousOrder) => {
      const currentItems = previousOrder?.ordersProducts || [];

      const existingItemIndex = currentItems.findIndex(
        (item) =>
          Number(item.productId) === Number(newItem.productId) &&
          Number(item.productOptionId || 0) ===
          Number(newItem.productOptionId || 0)
      );

      // אם אותו מוצר ואותה וריאציה כבר קיימים בהזמנה
      if (existingItemIndex !== -1) {
        const updatedItems = [...currentItems];

        updatedItems[existingItemIndex] = {
          ...updatedItems[existingItemIndex],
          amount:
            Number(updatedItems[existingItemIndex].amount || 0) +
            Number(newItem.amount || 1),
        };

        return {
          ...previousOrder,
          ordersProducts: updatedItems,
        };
      }

      // מוצר חדש בהזמנה
      return {
        ...previousOrder,
        ordersProducts: [
          ...currentItems,
          {
            ...newItem,

            // מזהה זמני בצד React בלבד
            temporaryId: `new-${Date.now()}-${Math.random()}`,
            isNew: true,
          },
        ],
      };
    });
  };

  const API_BASE =
    process.env.REACT_APP_API_BASE_URL || "";

  const resolveImgSrc = (img) => {
    if (!img) return null;
    if (img instanceof File) return URL.createObjectURL(img);
    const path = String(img).replace(/\\/g, "/"); // ליתר ביטחון אם הגיעו backslashes
    if (path.startsWith("http") || path.startsWith("//")) return path;
    return `${API_BASE}${path}`; // הופך "/       /..." ל־"https://localhost:7010/uploads/..."
  };



  const handlePrint = () => {
    printOrder(order, resolveImgSrc);
  };

  const translateOptionType = (type) => {
    switch (type) {
      case "Color":
        return "צבע";
      case "Size":
        return "מידה";
      default:
        return type; // fallback אם יתווסף סוג בעתיד
    }
  };
  const translatePaymentMethod = (paymentMethod) => {
    switch (paymentMethod) {
      case "CreditCard":
        return "כרטיס אשראי";

      case "BankTransfer":
        return "העברה בנקאית";

      case "PhonePayment":
        return "תשלום טלפוני";

      case "TicketCard":
        return "טיצר כארד / כארד כל";

      default:
        return "לא צוין";
    }
  };

  const calcTotal = (ordersProducts) => {
    return calculateCartTotal(ordersProducts);
  };

  const formatUserAddress = (user) => {
    const address = user?.userAddresses?.[0];

    if (!address) return "לא הוגדרה כתובת";

    return [
      address.city,
      `${address.street || ""} ${address.houseNumber || ""}`.trim(),
      address.apartment ? `דירה ${address.apartment}` : "",
      address.floor ? `קומה ${address.floor}` : "",
      address.entrance ? `כניסה ${address.entrance}` : "",
      address.notes ? `הערות: ${address.notes}` : "",
    ]
      .filter(Boolean)
      .join(", ");
  };

  return (
    <>
      {/* <AdminAddProduct/> */}
      {/* <Button variant="outlined" onClick={handleClickOpen}>
        Open dialog
      </Button> */}
      <BootstrapDialog
        onClose={(event, reason) => {
          if (saving || confirming) return;
          handleClose();
        }}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
        maxWidth="lg"
        disableEnforceFocus
        disableRestoreFocus
      >
        {/* .... */}

        <DialogTitle sx={{ m: 0, p: 2, position: "relative", pr: 6 }} id="customized-dialog-title">
          פרטי הזמנה

          <IconButton
            aria-label="print"
            onClick={handlePrint}
            sx={{
              position: 'absolute',
              left: 8,          // אם RTL, אפשר לשים ב-right: 8
              top: 8,
            }}
          >
            <PrintIcon />
          </IconButton>
        </DialogTitle>

        {/* <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton> */}
        <DialogContent dividers>
          <Box id={`order-print-${order.id}`}>
            {/* <Typography gutterBottom>
           {JSON.stringify(order)}
          </Typography> */}
            <Box sx={{ mb: 2 }}>
              <Typography variant="h6" gutterBottom>
                פרטי לקוח
              </Typography>
              <Box
                sx={{
                  mb: 2,
                  p: 1.5,
                  borderRadius: 2,
                  backgroundColor: localOrder.isCustomerNotified
                    ? "#e8f5e9"
                    : "#fff3e0",
                  border: localOrder.isCustomerNotified
                    ? "1px solid #81c784"
                    : "1px solid #ffb74d",
                }}
              >
                {localOrder.isCustomerNotified ? (
                  <>
                    <Typography
                      sx={{
                        color: "#2e7d32",
                        fontWeight: 800,
                      }}
                    >
                      ✓ ההזמנה המעודכנת כבר נשלחה ללקוח
                    </Typography>

                    {localOrder.customerNotifiedAt && (
                      <Typography
                        variant="body2"
                        sx={{
                          mt: 0.5,
                          color: "#4f6451",
                        }}
                      >
                        תאריך שליחה:{" "}
                        {new Date(
                          localOrder.customerNotifiedAt
                        ).toLocaleString("he-IL")}
                      </Typography>
                    )}
                  </>
                ) : (
                  <Typography
                    sx={{
                      color: "#e65100",
                      fontWeight: 800,
                    }}
                  >
                    ⏳ ההזמנה עדיין ממתינה לאישור ולשליחה ללקוח
                  </Typography>
                )}
              </Box>
              <Typography>שם: {order.user?.name}</Typography>
              <Typography>אימייל: {order.user?.email}</Typography>
              <Typography>טלפון: {order.user?.phone}</Typography>
              <Typography>
                כתובת: {order.shippingAddress || "לא הוגדרה כתובת להזמנה"}
              </Typography>
              <Typography >
                שיטת משלוח: {order?.shippingMethod}
              </Typography>
              <Typography >
                אמצעי תשלום: {translatePaymentMethod(order?.paymentMethod)}
              </Typography>
            </Box>
            <Divider
              sx={{
                mx: -2,
                my: 2,
                borderColor: "rgba(0,0,0,0.12)",
              }}
            />

            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                mb: 2,
              }}
            >
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => setOpenAddProduct(true)}
                disabled={saving || confirming}
                sx={{
                  backgroundColor: "#D81B60",
                  fontWeight: 700,

                  "&:hover": {
                    backgroundColor: "#ad1457",
                  },
                }}
              >
                הוספת מוצר להזמנה
              </Button>
            </Box>

            <List className="print-products-list">
              {localOrder.ordersProducts.map((orderProduct) => {
                const optionText = orderProduct.productOption
                  ? `${translateOptionType(orderProduct.productOption.optionType)}: ${orderProduct.productOption.value}`
                  : null;
                const displayImage =
                  orderProduct.productOption?.image || orderProduct.product?.image;

                console.log("order product:", orderProduct.product);



                return (
                  <React.Fragment
                    key={getOrderProductKey(orderProduct)}
                  >
                    <ListItem>
                      <Box
                        component="img"
                        src={resolveImgSrc(displayImage)}
                        alt={orderProduct.product?.name}
                        sx={{
                          width: 56,
                          height: 56,
                          borderRadius: 1,
                          objectFit: "cover",
                          ml: 2,
                        }}
                        onError={(e) => {
                          e.currentTarget.style.display = "none";
                        }}
                      />

                      <ListItemText
                        primary={
                          <>
                            <>
                              <Box sx={{ display: "inline-flex", width: "fit-content" }}>
                                <DealChip product={orderProduct.product} />
                              </Box>

                              <Typography sx={{ fontWeight: 600 }}>
                                {orderProduct.product?.name}
                                {optionText && ` (${optionText})`}
                              </Typography>
                            </>

                          </>
                        }
                        secondary={(() => {
                          const unitPrice = getUnitPrice(orderProduct);
                          const amount = Number(orderProduct.amount) || 0;
                          const lineTotal = calculateItemTotal(orderProduct);

                          return `כמות: ${amount} × ${unitPrice.toFixed(2)} ש"ח | סה"כ: ${lineTotal.toFixed(2)} ש"ח`;
                        })()}

                        sx={{ ml: 2, textAlign: "right" }}
                      />
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <QuantityCounter
                          value={orderProduct.amount}
                          max={orderProduct.product?.quantity}
                          onChange={(newAmount) =>
                            handleOrderProductAmountChange(
                              orderProduct,
                              newAmount
                            )
                          }

                        />

                        <IconButton
                          color="error"
                          onClick={() =>
                            handleRemoveOrderProduct(
                              orderProduct
                            )
                          }
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Box>
                    </ListItem>
                  </React.Fragment>
                );
              })}
            </List>

            <Box sx={{ mt: 2, p: 2, borderTop: "1px solid #ddd" }}>
              <OrderPriceWithDiscount order={localOrder} showTitle={true} />
            </Box>

            {/* פרטי הזמנה ולקוח */}



          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: 1,
            px: 2,
            py: 1.5,
          }}
        >
          <Button
            onClick={handleClose}
            disabled={saving || confirming}
          >
            ביטול
          </Button>

          <Box sx={{ display: "flex", gap: 1 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSaveOrder}
              disabled={saving}
            >
              {saving ? "שומר שינויים..." : "שמור שינויים"}
            </Button>

            <Button
              variant="contained"
              onClick={handleConfirmOrder}
              disabled={saving || confirming}
              sx={{
                backgroundColor: "#D81B60",
                fontWeight: 700,

                "&:hover": {
                  backgroundColor: "#ad1457",
                },
              }}
            >
              {confirming
                ? "שומר ושולח..."
                : "אישור הזמנה ושליחה ללקוח"}
            </Button>
          </Box>
        </DialogActions>
      </BootstrapDialog>

      <AdminAddProductToOrderDialog
        open={openAddProduct}
        onClose={() => setOpenAddProduct(false)}
        onAdd={handleAddProductToOrder}
      />
      <Dialog
        open={deleteDialogOpen}
        onClose={handleCancelDeleteProduct}
        maxWidth="xs"
        fullWidth
        sx={{
          zIndex: (theme) => theme.zIndex.modal + 10,
        }}
      >
        <DialogTitle sx={{ fontWeight: 700 }}>
          הסרת מוצר מההזמנה
        </DialogTitle>

        <DialogContent dividers>
          <Typography>
            האם את בטוחה שברצונך להסיר את המוצר
          </Typography>

          <Typography
            sx={{
              mt: 1,
              fontWeight: 700,
            }}
          >
            "
            {productToDelete?.product?.name ??
              productToDelete?.product?.Name ??
              "המוצר"}
            "
          </Typography>

          <Typography sx={{ mt: 1 }}>
            מההזמנה?
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleCancelDeleteProduct}
            color="inherit"
          >
            ביטול
          </Button>

          <Button
            onClick={handleConfirmDeleteProduct}
            variant="contained"
            color="error"
          >
            כן, להסיר
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}